/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Pulsing placeholder block for loading states (shimmer skeleton). The opacity
// animation rides an `Animated.View`; the background + size classes live on a
// real inner `<View>` because NativeWind's className is NOT applied to
// `Animated.View`.

import { useEffect, useRef } from 'react';
import { Animated, Platform, View, type ViewStyle } from 'react-native';

const IS_WEB = Platform.OS === 'web';

export interface SkeletonProps {
  /** Tailwind size/radius classes, e.g. "w-[80px] h-[80px] rounded-xl". */
  readonly className?: string;
  readonly style?: ViewStyle;
}

export function Skeleton({ className, style }: SkeletonProps): JSX.Element {
  const opacity = useRef(new Animated.Value(0.5)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, { toValue: 1, duration: 750, useNativeDriver: !IS_WEB }),
        Animated.timing(opacity, { toValue: 0.5, duration: 750, useNativeDriver: !IS_WEB }),
      ]),
    );
    loop.start();
    return () => loop.stop();
  }, [opacity]);

  return (
    <Animated.View style={{ opacity }}>
      <View
        style={style}
        className={`bg-light-surface-elevated dark:bg-dark-surface-elevated ${className ?? ''}`}
      />
    </Animated.View>
  );
}
